<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">Dedicated to R. D. Miln.</p><br/>
<p style="text-align: center;">Late Professor of Classics and Ancient History at the University of Queensland.</p><br/>
<p style="text-align: center;">Who over fifty years ago passed the Platonic spark to me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?8fa67128